// Пояснення до питання: не вивалюється саме — юзер тисне «Пояснення».
// Під ним — 👍/👎 з ЛІЧИЛЬНИКАМИ (видно всім, скільки людей оцінило) і скарга
// «не підходить до питання». Оцінки видно в адмінці, щоб виправляти слабкі.
import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';
import { getExplStyle } from '../lib/settings';

export function ExplanationBox({
  questionId,
  explanation,
}: {
  questionId: number;
  explanation: string;
}) {
  const [open, setOpen] = useState(false);
  const [up, setUp] = useState(0);
  const [down, setDown] = useState(0);
  const [myVote, setMyVote] = useState<number | null>(null);
  const [reported, setReported] = useState(false);
  const style = getExplStyle();

  // Лічильники тягнемо лише коли юзер реально відкрив пояснення
  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    void api.explanations
      .votes(questionId, style)
      .then((r) => {
        if (cancelled) return;
        setUp(r.up);
        setDown(r.down);
        setMyVote(r.myVote);
      })
      .catch(() => {
        /* офлайн/помилка — просто без лічильників */
      });
    return () => {
      cancelled = true;
    };
  }, [open, questionId, style]);

  async function send(v: 1 | -1, comment?: string) {
    if (myVote === v && !comment) return;
    haptic.light();
    // Оптимістично: одразу пересуваємо лічильники, потім звіряємо з сервером
    setUp((u) => u + (v === 1 ? 1 : 0) - (myVote === 1 ? 1 : 0));
    setDown((d) => d + (v === -1 ? 1 : 0) - (myVote === -1 ? 1 : 0));
    setMyVote(v);
    try {
      const r = await api.explanations.vote({ questionId, style, vote: v, comment });
      setUp(r.up);
      setDown(r.down);
    } catch {
      /* оцінка не критична — лишаємо оптимістичне значення */
    }
  }

  if (!open) {
    return (
      <button
        onClick={() => {
          haptic.light();
          setOpen(true);
        }}
        className="flex w-full items-center justify-center gap-2 rounded-xl border border-tg-link/40 bg-tg-link/5 px-4 py-2.5 text-sm font-semibold text-tg-link"
      >
        💡 Пояснення
      </button>
    );
  }

  return (
    <article className="rounded-xl border border-tg-link/40 bg-tg-link/5 p-3.5">
      <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-tg-link">
        <span>💡</span>
        <span>Пояснення</span>
      </div>
      <p className="whitespace-pre-line text-sm leading-relaxed text-tg-text">{explanation}</p>

      <div className="mt-3 flex items-center gap-2 border-t border-tg-link/20 pt-2.5">
        <span className="text-[11px] text-tg-hint">Корисно?</span>
        <button
          onClick={() => send(1)}
          className={`flex items-center gap-1 rounded-lg px-2.5 py-1 text-sm ${
            myVote === 1 ? 'bg-tg-success/20 text-tg-success' : 'bg-tg-bg text-tg-hint'
          }`}
          aria-label="Корисно"
        >
          <span>👍</span>
          <span className="text-xs font-semibold">{up}</span>
        </button>
        <button
          onClick={() => send(-1)}
          className={`flex items-center gap-1 rounded-lg px-2.5 py-1 text-sm ${
            myVote === -1 ? 'bg-tg-destructive/20 text-tg-destructive' : 'bg-tg-bg text-tg-hint'
          }`}
          aria-label="Не корисно"
        >
          <span>👎</span>
          <span className="text-xs font-semibold">{down}</span>
        </button>
        <div className="flex-1" />
        {reported ? (
          <span className="text-[11px] text-tg-success">Дякуємо, перевіримо</span>
        ) : (
          <button
            onClick={() => {
              setReported(true);
              void send(-1, 'Пояснення не підходить до питання');
            }}
            className="text-[11px] text-tg-hint underline-offset-2 hover:underline"
          >
            Не підходить до питання
          </button>
        )}
      </div>
    </article>
  );
}
